<template>
  <h1>ReceptionList</h1>
</template>

<script>
export default {
  name: "ReceptionList"
};
</script>

<style></style>
